import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HowItWorksSection from '../components/home/HowItWorksSection';
import CTASection from '../components/home/CTASection';

const HowItWorksPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="pt-32 pb-16 hero-gradient">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl">
              <span className="inline-block text-[#EE8C00] font-semibold text-sm tracking-wider uppercase mb-4">
                Our Process
              </span>
              <h1 className="heading-1 mb-6">
                Simple, Stress-Free Energy Upgrades
              </h1>
              <p className="body-large">
                We've streamlined the entire process so you can focus on the results, 
                not the paperwork. Here's exactly what to expect.
              </p>
            </div>
          </div>
        </section>

        <HowItWorksSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HowItWorksPage;
